import React from "react";
import { Outlet } from "react-router-dom";
import UserLayout from "../layouts/UserLayout/UserLayout.jsx";

const App = () => {
  return (
    <UserLayout>
      <Outlet />
    </UserLayout>
  );
};

export default App;
